export default "__VITE_ASSET__Ccpxmn52__"